<template>
  <div class="form-textarea-input form-item">
    <div class="form-item-content">
      <x-proxy-form-item
        :showRequired="showRequired"
        :label="widget.label"
        :processTitle="widget.processTitle"
        :validatorRules="validatorRules"
        :validateKey="validateKey"
        :validateInfo="validateInfo"
        :disabled="disabled"
      >
        <cube-textarea
          ref="textareaInputRef"
          v-if="renderSence === 'edit' && !widget.readOnly"
          v-model="textareaValue"
          :class="['form-input']"
          :disabled="disabled"
          :placeholder="placeholder"
          :maxlength="widget.lengthLimit"
          @input="textareaInputEvent"
        ></cube-textarea>
        <pre class="textarera-input-pre disabled" v-else-if="renderSence === 'edit'">{{ formValue }}</pre>
        <pre class="textarera-input-pre" v-if="renderSence === 'read'">{{ formValue || '-' }}</pre>
      </x-proxy-form-item>
      <div v-if="renderSence === 'edit' && !disabled" class="form-item-suffix">
        <x-svg-icon v-if="widget.enableScanCode" name="x-lib-scan" @click.native="handleScanQrcode"></x-svg-icon>
      </div>
    </div>
  </div>
</template>

<script>
import FormWidgetConfigMixin from '../../../mixins/form-widget.mixin'
import { scanQRCode } from '@/vender/third-sdk/third-function/scan-code.js'

export default {
  name: 'FormTextareaInput',
  mixins: [FormWidgetConfigMixin],
  computed: {
    textareaValue: {
      get() {
        return this.formValue || ''
      },
      set(value) {
        this.formValue = value
      }
    },
    placeholder() {
      return this.widget.enableRule 
        ? '自动生成'
        : this.widget.readOnly 
          ? '' 
          : this.widget.placeholder
    },
    disabled() {
      return this.widget.enableRule || this.widget.readOnly
    }
  },
  watch: {
    'widget.readOnly': {
      handler(newVal) {
        if (newVal === false && this.renderSence === 'edit') {
          this.$nextTick(() => {
            this.textareaInputEvent()
          })
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      console.log('计算高度')
      if (!this.widget.readOnly) {
        this.textareaInputEvent()
      }
    })
  },
  methods: {
    textareaInputEvent() {
      if (this.$refs.textareaInputRef.$refs.input.scrollHeight && this.$refs.textareaInputRef.$refs.input.scrollHeight <= 274) {
        this.$refs.textareaInputRef.$refs.input.style.height = 54 / 14 + 'rem'
        this.$nextTick(() => {
          this.$refs.textareaInputRef.$refs.input.style.height = this.$refs.textareaInputRef.$refs.input.scrollHeight / 14 + 'rem'
        })
      }
    },
    handleScanQrcode() {
      scanQRCode().then((resp) => {
        this.formValue = resp && resp.result
      })
    }
  }
}
</script>

<style lang="scss">
.form-textarea-input {
  background-color: $--app-light-color;

  .form-item-label {
    font-size: $--app-title-font-size;
    line-height: 1;
    display: flex;
    font-weight: $--app-base-font-weight;
  }
  .form-item-content {
    position: relative;
    .cube-textarea-wrapper {
      height: 100%;
      min-height: 3.857rem;
      max-height: 19.571rem;
    }
    .cube-textarea-wrapper::after {
      border: 0;
    }
    .cube-textarea {
      border: 0;
      font-size: $--app-title-font-size;
      color: $--app-base-font-color;
      padding: 0;
      margin-bottom: 0.429rem;
      min-height: 3.857rem;
      max-height: 19.571rem;
    }
    .textarera-input-pre {
      white-space: pre-wrap;
      word-wrap: break-word;
      line-height: 1.429;
      font-size: $--app-title-font-size;
      &.disabled {
        min-height: 3.857rem;
        margin-bottom: 0.429rem;
      }
    }
    .cube-textarea_expanded {
      min-height: 3.857rem;
      max-height: 19.571rem;
    }
    .cube-textarea-indicator {
      display: inline-block !important;
      bottom: -0.429rem;
    }
    .cube-textarea_active::after {
      border: 0 !important;
    }
    .readonly-background {
      background-color: $--app-form-readonly-bgColor !important;

      .cube-textarea {
        background-color: $--app-form-readonly-bgColor !important;
        color: $--app-base-font-color !important;
      }
      textarea:disabled {
        opacity: 1 !important;
      }
    }
    .form-item-suffix {
      position: absolute;
      top: 0.71rem;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 0 0 3.43rem;
      justify-content: center;
      width: 3.43rem;
      font-size: 0;
    }
  }
}
</style>